module.exports = __webpack_public_path__ + "img/video.dba7584f.png";